
import { Component, Vue } from "vue-property-decorator";

import ApplicationFooter from "@/components/ApplicationFooter.vue";
import ApplicationHeader from "@/components/ApplicationHeader.vue";
import { SnackbarService } from "@/services";
import store, { ApplicationModule, getStoreModule } from "@/store";
import { SearchItem } from "@/types";

const applicationStore = getStoreModule(ApplicationModule, store);

@Component({
  components: {
    ApplicationHeader,
    ApplicationFooter,
  },
  computed: {
    snackbarState: {
      get(): boolean {
        return applicationStore.getSnackbarState;
      },
      async set(value: boolean) {
        applicationStore.setSnackbarState(value);
      },
    },
    snackbarMessage: {
      get(): string {
        return applicationStore.getSnackbarMessage;
      },
    },
    snackbarSearchItem: {
      get(): SearchItem | null {
        return applicationStore.getSnackbarItemBeingMoved;
      },
    },
    snackbarTimeout: {
      get(): number {
        return applicationStore.getSnackbarTimeout;
      },
    },
    snackbarColor: {
      get(): string {
        return applicationStore.getSnackbarColor;
      },
    },
  },
})
export default class App extends Vue {
  openMoveDialog(): void {
    // Retrieve the search item from the snackbar store, and set it as the
    // briefcase item. This will trigger the modal to appear.
    const searchItem = applicationStore.getSnackbarItemBeingMoved;
    applicationStore.setBriefcaseItemBeingMoved(searchItem);

    // Close out and reset snackbar.
    SnackbarService.closeSnackbar();
  }
}
